import { Box, Grid, Typography } from '@mui/material';
import type { DiagnosticAction } from 'types/Spark/SparkDiagnostics';
import type { GridProps } from '@mui/material';

type SparkHealthActionsProps = {
  actions: DiagnosticAction[];
  containerStyles?: GridProps;
  columnCount?: number;
};

function SparkHealthActions({
  actions,
  columnCount = 2,
  containerStyles,
}: SparkHealthActionsProps) {
  const itemsPerColumn = Math.ceil(actions.length / columnCount);
  const columns = Array.from({ length: columnCount }, (_, colIndex) =>
    actions.slice(colIndex * itemsPerColumn, (colIndex + 1) * itemsPerColumn)
  );

  return (
    <Grid container {...containerStyles}>
      {columns.map((columnItems, colIndex) => (
        <Grid item xs={5} key={colIndex}>
          {columnItems.map((action, rowIndex) => (
            <Box display='flex'>
              <Box
                key={rowIndex}
                component='img'
                src={action.iconURL}
                alt={action.name}
                sx={{ aspectRatio: 1, width: '20px' }}
              />
              <Typography
                sx={{ marginLeft: 2 }}
                component='span'
                variant='body1'
              >
                {action.name}
              </Typography>
            </Box>
          ))}
        </Grid>
      ))}
    </Grid>
  );
}

export default SparkHealthActions;
